import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React from 'react';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import validAllowedCharacters from '../../../constants/valid-character-password';
import {
  BOMFilterInitialState,
  TagsFilterInitialState,
} from '../../../core/initialState/filter-initial-state';
import { IUserFilter } from '../../../models/IUserFilter';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import { formatMessage } from '../../../translations/format-message';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import { FilterValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import { IOption } from '../../../models/ICommon';
import { IBOMSearchFilter } from '../../../models/IBOMSearchFilter';
import {
  DateFormatForDatePickerJP,
  DateFormatNew,
} from '../../../constants/date-picker-constant';
import { InfoCircle } from 'react-bootstrap-icons';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: any;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  isLoading: boolean;
  isFilterCleared: boolean;
  processOptions: IOption[];
  materialClassificationOptions: IOption[];
}

const FilterComponent = (props: IProps) => {
  function getLocalISODate(isoDate: Date) {
    return (
      isoDate.getFullYear() +
      '-' +
      String(isoDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(isoDate.getDate()).padStart(2, '0') +
      'T' +
      String(isoDate.getHours()).padStart(2, '0') +
      ':' +
      String(isoDate.getMinutes()).padStart(2, '0') +
      ':' +
      String(isoDate.getSeconds()).padStart(2, '0')
    );
  }
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          ...props.initialValues,
          StartDate:
            props.initialValues.StartDate === '2025-01-01'
              ? ''
              : props.initialValues.StartDate,
          EndDate: (() => {
            const endDate = props.initialValues?.EndDate;
            if (!endDate) return '';

            const today = new Date();
            today.setFullYear(today.getFullYear() + 5);

            const format = (d) => {
              const year = d.getFullYear();
              const month = String(d.getMonth() + 1).padStart(2, '0');
              const day = String(d.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            };

            const futureDate = format(today);

            return endDate === futureDate ? '' : endDate;
          })(),
        }}
        enableReinitialize
        validationSchema={FilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values: IBOMSearchFilter, { resetForm }) => {
          if (values.StartDate) {
            values = {
              ...values,
              StartDate: `${getLocalISODate(new Date(values.StartDate)).slice(
                0,
                10
              )}`,
            };
          }
          if (values.EndDate) {
            values = {
              ...values,
              EndDate: `${getLocalISODate(new Date(values.EndDate)).slice(
                0,
                10
              )}`,
            };
          }
          props.submitHandler(values);
        }}
      >
        {({ dirty, resetForm, values }) => (
          <FormikForm className="user-form pt-2 px-4">
            {props.isLoading && <FormLoader loading={props.isLoading} />}

            <Row>
              <Col md={3}>
                <div className="form-group">
                  <Label
                    className="label-style  col-form-label"
                    required={false}
                    label="next_process"
                    htmlFor="NextProcess"
                  />
                  <Field
                    data-testid="NextProcess"
                    className="form-control"
                    name="NextProcess"
                    autoComplete="off"
                    placeholder=""
                    as={FormikFormSelect}
                    options={props.processOptions}
                  />
                </div>
              </Col>
              <Col md={3}>
                <Label
                  className="label-style  col-form-label"
                  required={false}
                  label="start_date"
                  htmlFor="StartDate"
                />
                <Field
                  data-testid="StartDate"
                  className="form-control"
                  name="StartDate"
                  autoComplete="off"
                  placeholder=""
                  as={FormikFormDatePicker}
                  isClearable={values.StartDate}
                  maxDate={values.EndDate ? new Date(values.EndDate) : undefined}
                  //validcharacter={validCharacters}
                />
              </Col>
              <Col md={3}>
                <div className="form-group">
                  <Label
                    className="label-style  col-form-label"
                    required={false}
                    label="end_date"
                    htmlFor="EndDate"
                  />
                  <Field
                    data-testid="EndDate"
                    className="form-control"
                    name="EndDate"
                    autoComplete="off"
                    placeholder=""
                    as={FormikFormDatePicker}
                    isClearable={values.EndDate}
                    minDate={values.StartDate ? new Date(values.StartDate) : undefined}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="material_katashiki"
                    htmlFor="MaterialKatashiki"
                  />
                  <Field
                    data-testid="MaterialKatashiki"
                    className="form-control"
                    name="MaterialKatashiki"
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    as={FormikFormInput}
                    validcharacter={validAllowedCharacters}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="material_classification"
                    htmlFor="MaterialClassificationValue"
                  />
                  <Field
                    data-testid="MaterialClassification"
                    className="form-control"
                    name="MaterialClassificationValue"
                    autoComplete="off"
                    placeholder=""
                    as={FormikFormSelect}
                    options={props.materialClassificationOptions}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="form-group">
                  <Label
                    className="label-style col-form-label"
                    label="sub_contractor_name"
                  />
                  <Field
                    data-testid="testProcessName"
                    className="form-control"
                    name="SubContractorName"
                    type="text"
                    placeholder=""
                    as={FormikFormInput}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="free_text_search"
                    htmlFor="FreeTextSearch"
                  />
                  <Field
                    data-testid="FreeTextSearch"
                    className="form-control"
                    name="FreeTextSearch"
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    as={FormikFormInput}
                    validcharacter={validAllowedCharacters}
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="clear-filter-btn bom-serch-btn ">
                  <Button
                    className="text-white bom-clear-btn"
                    onClick={() => {
                      props.filterParmas({ ...BOMFilterInitialState }, true);
                      resetForm();
                    }}
                    disabled={props.isFilterCleared}
                  >
                    {formatMessage('clear_all_filters')}
                  </Button>
                  <Button
                    className="ms-3"
                    variant="secondary"
                    type="submit"
                  >
                    {formatMessage('search')}
                  </Button>
                </div>
              </Col>
            </Row>
          </FormikForm>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
